import './index.css';
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
import Amplify from 'aws-amplify';
import {amplifyConfig} from "./AmplifyConfig";
import * as serviceWorker from './serviceWorker';
import {BrowserRouter as Router} from 'react-router-dom';

// Suppress specific warnings from material-table
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('Warning: React does not recognize the `scrollWidth` prop')
  ) {
    return;
  }
  originalError.call(console, ...args);
};

Amplify.configure(amplifyConfig);

ReactDOM.render(
    <Router>
        <App/>
    </Router>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
